///all in one
import axios from "@/axios";
export const shopcardStates = [];

export const shopcardGetters = {
  getShopcard: state => {
    return state.shopcardStates?state.shopcardStates.filter(v=>v.active==true):[];
  },
  getUnselectedShopcard: state => {
    return state.shopcardStates?state.shopcardStates.filter(v=>v.active==false):[];
  },
  getAllShopcard: state => {
    return state.shopcardStates;
  },
};

export const shopcardMutations = {
  changeShopcard(state, value) {
    state.shopcardStates = value;
  }
};

export const shopcardActions = {
  act_shopcard: async ({ commit,getters }) => {
    //console.log('it is token:',getters.getAuthToken);
    const respone = await axios.get("get-participant-card"
    ,{
        headers: {
            Authorization: "Bearer " + getters.getAuthToken
        }
    });
    const data = respone.data.data.map(item=>{
      item.active = true;
      return item;
    });
    //console.log('it is respone:',respone);
    commit("changeShopcard", data);
    return true;
  }

};
